import FEATURE from './FEATURE';

export default Object.fromEntries(Object.values(FEATURE).map((feature) => [feature.value, feature]));
